import React from "react"
import Dropzone from "react-dropzone"
import { useController } from "react-hook-form"
import PropTypes from "prop-types"
import { t } from "i18next"
import { FormGroup, FormText } from "reactstrap"

function DropzoneRHF({ name, control, ...otherProps }) {
  const {
    field: { value, onChange },
    fieldState,
  } = useController({ control, name })
  return (
    <FormGroup>
      <Dropzone onDrop={onChange} {...otherProps}>
        {({ getRootProps, getInputProps }) => (
          <div className={`dropzone ${fieldState.invalid ? "invalid" : null}`}>
            <div className="dz-message needsclick" {...getRootProps()}>
              <input {...getInputProps()} accept="image/*,.pdf" />
              <div className="mb-1">
                <i className="display-6 text-muted bx bxs-cloud-upload" />
              </div>
              <h6>{t("drop files here or click to upload")}.</h6>
              {value?.length > 0 ? (
                <p className="font-size-15 text-success">{t("files were selected", { number: value.length })}</p>
              ) : null}
            </div>
          </div>
        )}
      </Dropzone>
      {fieldState.error ? (
        <FormText color="danger">{fieldState?.error?.message}</FormText>
      ) : null}
    </FormGroup>
  )
}
DropzoneRHF.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
}
export default DropzoneRHF
